import { useCallback } from 'react'

import { filter } from 'lodash'
import { useSelector } from 'react-redux'

import { useIsAuthed } from 'components/AuthShield'
import { selectContentTags } from 'store/content-tags'

import ResultComponent from './ResultComponent'

interface ITag {
  tag: string
}

export const label = 'Posts'

const MAX_RESULT_COUNT = 20

const getTag = ({ tag }: ITag) => {
  return {
    label: tag,
    searchTypeLabel: label,
  }
}

export const contentTagSearch = (term: string, tags: ITag[]) => {
  if (!term) {
    return []
  }
  const sanitizedTerm = term.replace(/[^a-zA-Z0-9 ]/g, '')
  const filtered = filter(tags, ({ tag }) => new RegExp(sanitizedTerm, 'gi').test(tag))
  return filtered.slice(0, MAX_RESULT_COUNT).map(getTag)
}

export const getSearch = (tags: ITag[]) => {
  const searchFn = (term: string) => {
    const results = contentTagSearch(term, tags)
    return Promise.resolve(results)
  }
  return searchFn
}

export const usePostsSearchConfig = () => {
  const tags = useSelector(selectContentTags)
  const isAuthed = useIsAuthed()

  const search = useCallback(
    (term: string) => {
      return new Promise((resolve) => {
        resolve(contentTagSearch(term, tags))
      })
    },
    [tags],
  )

  return {
    label,
    search,
    ResultComponent,
    allLimit: 3,
    placeholderOption: 'Search all across Scoir',
    hidden: !isAuthed,
  }
}
